import React from 'react';
import { Button, Cell, Input, Toast } from 'zarm';
import Selected from '@P/static/images/Selected.png';
import UnSelected from '@P/static/images/unSelected.png';
import { dispatch } from '@/store';
import './index.less';

const Index = ({
  questionList,
  holderList,
  isFillIn
}) => {
  // console.log('QA   ============>   : ', questionList);
  const specifiedTypeComponent = (item, question, answer) => {
    var _item$options, _item$options2, _item$options3;

    const result = answer === null || answer === void 0 ? void 0 : answer.answerList.find(res => res.index === item.index);
    return /*#__PURE__*/React.createElement(React.Fragment, null, item.dataType === 'input' && !item.isDefault ? /*#__PURE__*/React.createElement("div", {
      className: "questionWrap"
    }, /*#__PURE__*/React.createElement("p", {
      className: "questionTitle"
    }, `${item.desc}`), /*#__PURE__*/React.createElement(Input, {
      clearable: true,
      type: "text",
      placeholder: "\u8BF7\u8F93\u5165",
      className: "border-bottom-show",
      onChange: value => {
        result.value = value;
        answer.reply = answer.answerList.reduce((res, cur) => `${res}${cur.value || '无'}/`, '');
        dispatch({
          'questionList.holderList': [...holderList]
        });
      }
    })) : item.isShow && /*#__PURE__*/React.createElement("div", {
      className: "other"
    }, /*#__PURE__*/React.createElement("span", null, item.desc || '其他原因：'), /*#__PURE__*/React.createElement(Input, {
      clearable: true,
      type: "text",
      placeholder: "\u8BF7\u8F93\u5165",
      onChange: value => {
        result.value = value;
        answer.reply = answer.answerList.reduce((res, cur) => `${res}${cur.value || '无'}/`, '');
        dispatch({
          'questionList.holderList': [...holderList]
        });
      }
    })), item.dataType === 'select' && /*#__PURE__*/React.createElement("div", {
      className: "questionWrap"
    }, /*#__PURE__*/React.createElement("p", {
      className: "questionTitle"
    }, `${item.desc}`), ((_item$options = item.options) === null || _item$options === void 0 ? void 0 : _item$options.length) && item.options.map(option => {
      return /*#__PURE__*/React.createElement("div", {
        className: "selectWrap",
        key: `option-${option.label}`
      }, /*#__PURE__*/React.createElement("div", {
        onClick: () => {
          if (option !== null && option !== void 0 && option.relation) {
            question.questionList.forEach(res => {
              if (res.isDefault) {
                res.isShow = true;
              }
            });
          } else {
            question.questionList.forEach(res => {
              if (res.isDefault) {
                res.isShow = false;
              }
            });
            answer.answerList.forEach(r => {
              r.value = '';
            });
          }

          result.value = option.value;
          answer.reply = answer.answerList.reduce((res, cur) => `${res}${cur.value || '无'}/`, '');
          dispatch({
            'questionList.holderList': [...holderList]
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "item"
      }, /*#__PURE__*/React.createElement("img", {
        src: (result === null || result === void 0 ? void 0 : result.value) === option.value ? Selected : UnSelected,
        alt: ""
      }), /*#__PURE__*/React.createElement("span", null, `${option.label}`))));
    })), item.dataType === 'boolean' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "questionWrap"
    }, /*#__PURE__*/React.createElement("div", {
      className: "booleanWrap"
    }, /*#__PURE__*/React.createElement("p", {
      className: "questionTitle"
    }, `${question.content}`), /*#__PURE__*/React.createElement("div", {
      className: "isSure"
    }, /*#__PURE__*/React.createElement("p", {
      className: `${(result === null || result === void 0 ? void 0 : result.value) === 'Y' ? 'isYes' : 'yes'}`,
      onClick: () => {
        result.value = 'Y';
        answer.reply = answer.answerList.reduce((res, cur) => `${res}${cur.value || '无'}/`, '');
        dispatch({
          'questionList.holderList': [...holderList]
        });
      }
    }, "\u662F"), /*#__PURE__*/React.createElement("p", {
      className: `${(result === null || result === void 0 ? void 0 : result.value) === 'N' ? 'isNo' : 'no'}`,
      onClick: () => {
        result.value = 'N';
        answer.reply = answer.answerList.reduce((res, cur) => `${res}${cur.value || '无'}/`, '');
        dispatch({
          'questionList.holderList': [...holderList]
        });
      }
    }, "\u5426")))), !((_item$options2 = item.options) !== null && _item$options2 !== void 0 && _item$options2.length) && ((_item$options3 = item.options) === null || _item$options3 === void 0 ? void 0 : _item$options3.map(r => {
      return /*#__PURE__*/React.createElement("p", {
        key: `option-${r.label}`
      }, "\u53EF\u80FD\u662F\u5355\u9009\u5185\u5BB9");
    }))));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "holder-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "holder-container"
  }, /*#__PURE__*/React.createElement("h2", null, "\u6295\u4FDD\u4EBA\u544A\u77E5"), /*#__PURE__*/React.createElement("div", {
    className: "bodySide"
  }, /*#__PURE__*/React.createElement(Cell, {
    title: "\u8EAB\u9AD8cm\uFF1A"
  }, /*#__PURE__*/React.createElement(Input, {
    clearable: true,
    type: "text",
    placeholder: "\u8BF7\u8F93\u5165",
    maxLength: 3,
    onChange: value => dispatch('formValues.holder.height', value)
  })), /*#__PURE__*/React.createElement(Cell, {
    title: "\u4F53\u91CDkg\uFF1A"
  }, /*#__PURE__*/React.createElement(Input, {
    clearable: true,
    type: "text",
    placeholder: "\u8BF7\u8F93\u5165",
    maxLength: 3,
    onChange: value => dispatch('formValues.holder.weight', value)
  }))), /*#__PURE__*/React.createElement("div", {
    className: "informedTheInsured"
  }, questionList.map(question => {
    const answer = holderList === null || holderList === void 0 ? void 0 : holderList.find(item => item.code === question.code);
    return /*#__PURE__*/React.createElement("div", {
      key: `question-${question.code}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "optionsList"
    }, question.questionList.map(title => {
      return /*#__PURE__*/React.createElement("div", {
        key: `options-${title.desc}`
      }, specifiedTypeComponent(title, question, answer));
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: "holder-footer-button"
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    shape: "radius",
    className: "button",
    onClick: () => {
      const result = !!holderList.find(res => res.reply === '');
      console.log('result: ', result);

      if (result) {
        Toast.show('请仔细检查问卷是否全部填写无误!');
        return;
      }

      window.scrollTo(0, 0);
      isFillIn('notifyOBOpen');
    }
  }, "\u586B\u5199\u88AB\u4FDD\u4EBA\u544A\u77E5"))));
};

export default Index;